// Module
var code = "<h2 id=\"phone\">Phone</h2> <p>Need your questions answered quickly? Call us toll-free today.</p> ";
// Exports
export default code;